import { Divider, Form } from 'antd'
import React, { useEffect } from 'react'
import { useTranslation } from 'next-i18next'
import styles from './ProjectFormStock.module.scss'
import * as sections from './form-price.components'
import { CustomText, CustomTable } from 'src/components'
import { discountListColumns } from 'src/core/table-columns'
import { useAppDispatch, useAppSelector, useWindowSize } from 'src/app/hooks'
import {
  ProjectFormStepsType,
  ProjectDiscountPayload,
  ProjectFormStockPayload,
} from 'src/core/models'
import {
  isContributionUnitSelectedSelector,
  isVintageFormErrorVisibleSelector,
  isFreeDonationSelectedSelector,
  priceStockFormValuesSelector,
  projectFormStateSelector,
  setProjectFormItemValue,
  projectFormKindSelector,
  isVintageSelector,
} from 'src/features'

const ProjectFormStock: React.FC = () => {
  const { t } = useTranslation()
  const dispatch = useAppDispatch()
  const formValues = useAppSelector(priceStockFormValuesSelector)
  const isVintageSelected = useAppSelector(isVintageSelector)
  const selectedKind = useAppSelector(projectFormKindSelector)
  const isFreeDonationSelected = useAppSelector(isFreeDonationSelectedSelector)
  const isVintageErrorVisible = useAppSelector(isVintageFormErrorVisibleSelector)
  const contributionUnitSelected = useAppSelector(isContributionUnitSelectedSelector)
  const { discounts, contributionProjectType } = useAppSelector(projectFormStateSelector)
  const [form] = Form.useForm()
  const { isMobile } = useWindowSize()

  const onFinish = (values: ProjectFormStockPayload) => {
    if (!isVintageErrorVisible) {
      dispatch(setProjectFormItemValue({ key: 'contribution_unit', value: values.contribution_unit }))
      dispatch(setProjectFormItemValue({ key: 'price', value: values.price }))
      dispatch(setProjectFormItemValue({ key: 'currency_token', value: +values.currency_token }))
      dispatch(setProjectFormItemValue({ key: 'volume_credits', value: values.volume_credits }))
      const newStep: ProjectFormStepsType = selectedKind === 'contribution' ? 'CONFIGURATION' : 'CERTIFICATION'
      dispatch(setProjectFormItemValue({ key: 'activeStep', value: newStep }))
    }
  }

  useEffect(() => {
    form.setFieldsValue({
      ['contribution_unit']: formValues.contribution_unit,
      ['volume_credits']: formValues.volume_credits,
      ['price']: formValues.price,
      ['currency_token']: formValues.currency_token
    })
  }, [form, formValues])

  return <div className={styles.content}>
    <Form onFinish={onFinish} form={form}>

      {/* Contribution Project Type */}
      {selectedKind === 'contribution' && <sections.ProjectContributionUnitTypeForm />}

      {/* Contribution Unit Selector */}
      {(selectedKind === 'contribution' && contributionUnitSelected) && <sections.ProjectContributionUnitSelector />}

      {/* Tons Available */}
      {!isFreeDonationSelected && <sections.ProjectFormTonsAvailable />}

      {/* Project Price */}
      <sections.ProjectFormPrice />

      {/* Submit Button */}
      <div className={styles.submitContent}>

        {/* Project Discount Form */}
        {contributionProjectType !== 'FREE_DONATION' && (
          <sections.ProjectFormDiscountContent />
        )}

        <div className={styles.submitButton}>
          <sections.ProjectFormButtonContinue />
        </div>
      </div>
    </Form>

    {/* Project Vintages */}
    {isVintageSelected && <>
      <sections.ProjectFormVintageItems />
      {isVintageErrorVisible && <CustomText
        label={t('Projects.OneVintageRequired')}
        type='danger'
        className='ml-5'
      />}
    </>}

    {/* Discounts Table */}
    {discounts.length > 0 && <div className={!isMobile && 'pl-5 pr-5'}>
      <Divider />
      <CustomTable
        columns={discountListColumns}
        dataSource={discounts}
        rowKey={(discount: ProjectDiscountPayload) => discount.id}
      />
    </div>}
  </div>
}

export default ProjectFormStock

